// extracted by mini-css-extract-plugin
export default {"activePrincipleOption":"ActivePrinciplesSelect_activePrincipleOption__WlbPA","activePrincipleOptionLabel":"ActivePrinciplesSelect_activePrincipleOptionLabel__NpU8N"};